export default function forIE() {
  moveIE();
}

// 初期値でtransition:noneにしておいて、ページがロードされたらclass:preloadを外す
function moveIE() {
  window.onload = function() {
    const preload = document.getElementsByClassName("preload");
    preload[0].classList.remove("preload");
  };
}
